interface Properties {
  params: Record<string, string | number | null | Array<string>>;
}

export function createQueryString({ params }: Properties) {
  const filteredKeys = Object.entries(params).filter(([, value]) =>
    Array.isArray(value) ? value.length : value || value === 0
  );
  if (filteredKeys.length > 0) {
    // eslint-disable-next-line unicorn/no-array-reduce
    return filteredKeys.reduce((sum, [key, value], index) => {
      const separator = index ? "&" : "";
      if (Array.isArray(value)) {
        if (value.length > 0) {
          return `${sum}${separator}${value
            .map((item, index) => `${index ? "&" : ""}${key}=${item}`)
            .join("")}`;
        }
        return sum;
      }
      return `${sum}${separator}${key}=${value}`;
    }, "?");
  }
  return "";
}
